import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { News, NewsDto } from '../models';
import { Observable } from 'rxjs';
import { mapDto } from '@shared/operators';

@Injectable({
    providedIn: 'root',
})
export class HttpService {
    private readonly httpClient = inject(HttpClient);

    getNews(): Observable<News[]> {
        return this.httpClient.get<NewsDto[]>('library/news').pipe(mapDto((response) => response.map((item) => new News(item))));
    }
}
